import { ColumnDef } from '@tanstack/react-table';
import { NpsCampaignDto } from '@area-restrita/api-client/model/npsCampaignDto';

import { Badge } from '@/components/ui/badge';
import {
  NPS_STATUS_LABELS,
  formatDateRange,
  formatDateTime,
  formatParticipationRate,
} from '@/modules/nps/utils';

import NpsCampaignActionsCell from './NpsCampaignActionsCell';

export const columns: ColumnDef<NpsCampaignDto>[] = [
  {
    accessorKey: 'name',
    header: 'Nome',
  },
  {
    accessorFn: (row) => row.company.tradingName,
    id: 'company',
    header: 'Empresa',
    meta: { className: 'hidden md:table-cell' },
  },
  {
    accessorKey: 'companyId',
    id: 'companyIds',
    enableHiding: false,
    meta: { className: 'hidden' },
  },
  {
    id: 'periodStart',
    enableHiding: false,
    meta: { className: 'hidden' },
  },
  {
    id: 'periodEnd',
    enableHiding: false,
    meta: { className: 'hidden' },
  },
  {
    id: 'period',
    header: 'Período',
    cell: ({ row }) => formatDateRange(row.original),
    meta: { className: 'hidden md:table-cell' },
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row }) => (
      <Badge
        variant={row.original.status === 'closed' ? 'outline' : 'secondary'}
      >
        {NPS_STATUS_LABELS[row.original.status]}
      </Badge>
    ),
  },
  {
    accessorKey: 'responsesCount',
    header: 'Respostas',
    meta: { className: 'text-right' },
  },
  {
    accessorKey: 'eligibleUsersCount',
    header: 'Elegíveis',
    meta: { className: 'hidden text-right xl:table-cell' },
  },
  {
    id: 'participation',
    header: 'Participação',
    cell: ({ row }) => formatParticipationRate(row.original),
    meta: { className: 'hidden text-right md:table-cell' },
  },
  {
    accessorKey: 'openedAt',
    header: 'Aberta em',
    cell: ({ row }) => formatDateTime(row.original.openedAt),
    meta: { className: 'hidden xl:table-cell' },
  },
  {
    accessorKey: 'closedAt',
    header: 'Encerrada em',
    cell: ({ row }) => formatDateTime(row.original.closedAt),
    meta: { className: 'hidden xl:table-cell' },
  },
  {
    id: 'actions',
    header: 'Ações',
    meta: {
      className: 'text-right',
      onClick: (event) => event.stopPropagation(),
    },
    cell: ({ row }) => <NpsCampaignActionsCell campaign={row.original} />,
  },
];
